import { useEffect, useState } from "react";
import { Button, Input, Form, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { loginResponse, setLoading } from "../../store/common/commonActions";
import Localize from "../../utils/string";
import { LoginMdl } from "../../Modal/Login";
import { globalErrorResp } from "../../store/users/userActions";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
const { Title } = Typography;

const Login = () => {
  const loginResp = useSelector((state: any) => state.user.userSession);
  const previousLocation = useSelector(
    (state: any) => state.products.previousLocation
  );
  const Loading = useSelector((state: any) => state.common.loading);
  const loginErrorRes = useSelector(
    (state: any) => state.user.globalErrorObject
  );

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    scrollToTop();
    dispatch(setLoading(false));
  }, []);
  useEffect(() => {
    if (loginResp) {
      dispatch(setLoading(false));
      dispatch(globalErrorResp(undefined));
      if (previousLocation?.length > 0) {
        history.goBack();
      } else {
        if(loginResp.firstTime_Logged_In){
          history.push("/profile");
        }else{
          history.push("/");
        }
        
      }
    } else if (loginErrorRes) {
      dispatch(setLoading(false));
    }
  }, [loginResp, loginErrorRes, previousLocation]);

  const handleLogin = async (values: any) => {
    dispatch(setLoading(true));
    if (values.email && values.password) {
      const data: LoginMdl = {
        email: values.email,
        password: values.password,
      };
      try {
        await dispatch(loginResponse(data));
        setLoading(false);
      } catch (error) {}
    }
  };
  const scrollToTop = () => {
        
    const top = document.getElementById("top") as HTMLElement;
    top.scrollIntoView();



};
  return (
    <div className="login-page" id="top">
      <div className="login-page-inner">
        <Title level={2}>{Localize.LoginTitle}</Title>
        <Form name="loginForm" onFinish={handleLogin}>
          <Form.Item
            name="email"
            rules={[
              { 
                type: "email", 
                message: "Please enter valid email" 
              },
              { required: true, message: "Please Enter Email" },
            ]}
          >
            <Input placeholder="Enter your email" type="email" />
          </Form.Item>
          <Form.Item
            name="password"
            className="password-field"
            rules={[
              {
                required: true,
                message: "Please Enter Password",
              },
            ]}
          >
            <Input type="password" placeholder="Enter your password" />
          </Form.Item>
          <Link to="/forgotPassword" className="forgot-password-title">Forgot your password?</Link>
          <Button
            loading={Loading}
            className="rounded-btn"
            htmlType="submit"
            shape="circle"
          >
            {Localize.LoginButtonTitle}
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default Login;
